// src/components/CommentTable.js
import React from 'react';
import { deleteComment } from '../firebase/comments';

const CommentTable = ({ comments, isLoading, user, onError }) => {
  const handleDelete = async (commentId, authorId) => {
    // Only allow users to delete their own comments
    if (authorId !== user.uid) {
      onError("You can only delete your own comments.");
      return;
    }
    
    if (window.confirm('Are you sure you want to delete this entry?')) {
      try {
        await deleteComment(commentId);
        // The UI will update automatically through the real-time listener
      } catch (error) {
        console.error("Error deleting comment:", error);
        if (onError) {
          onError("Failed to delete comment. Please try again.");
        }
      }
    }
  };
  
  const formatDate = (isoString) => {
    try {
      const date = new Date(isoString);
      return date.toLocaleString();
    } catch (e) {
      return "Invalid date";
    }
  };
  
  if (isLoading) {
    return (
      <div className="comments-table-container">
        <h3>Comments and Citations</h3>
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading comments...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="comments-table-container">
      <h3>Comments and Citations</h3>
      {comments.length === 0 ? (
        <p className="no-comments">No comments or citations yet. Be the first to add one!</p>
      ) : (
        <div className="comments-list">
          {comments.map((comment) => (
            <div key={comment.id} className={`comment-card ${comment.type}`}>
              <div className="comment-header">
                <div className="comment-type-badge">
                  {comment.type === 'comment' ? 'Comment' : 'Citation'}
                </div>
                <div className="comment-date">{formatDate(comment.timestamp)}</div>
              </div>
              
              {comment.type === 'comment' ? (
                // Comment display
                <div className="comment-content">
                  <div className="comment-author">
                    {comment.authorPhoto && (
                      <img src={comment.authorPhoto} alt={comment.author} className="author-photo" />
                    )}
                    <span>{comment.author}</span>
                  </div>
                  <p className="comment-text">{comment.text}</p>
                </div>
              ) : (
                // Citation display
                <div className="citation-content">
                  <div className="citation-source">
                    <h4>{comment.articleTitle}</h4>
                    <p className="citation-author">by {comment.author}</p>
                    {comment.publication && (
                      <p className="citation-publication">{comment.publication}</p>
                    )}
                    {comment.publicationDate && (
                      <p className="citation-date">
                        Published: {new Date(comment.publicationDate).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                  <blockquote className="citation-text">
                    "{comment.citationText}"
                  </blockquote>
                  {comment.url && (
                    <a 
                      href={comment.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="citation-link"
                    >
                      View Source
                    </a>
                  )}
                  <div className="citation-submitter">
                    Submitted by: {comment.submittedBy}
                  </div>
                </div>
              )}
              
              {/* Show delete button only for user's own comments */}
              {(comment.type === 'comment' && comment.authorId === user.uid) || 
               (comment.type === 'citation' && comment.submitterId === user.uid) ? (
                <button 
                  onClick={() => handleDelete(
                    comment.id, 
                    comment.type === 'comment' ? comment.authorId : comment.submitterId
                  )}
                  className="delete-comment-button"
                >
                  Delete
                </button>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommentTable;